import React from "react"
import { FlatList, TouchableOpacity, View } from "react-native"
import { AppModal as Modal } from "../atoms/AppModal"
import { Text } from "../atoms"
import { getCommonStyles, SelectionItem } from "@utils"
import { useTheme } from "@react-navigation/native"

export const PickerModal = ({isVisible, setIsVisible, value, title, position, onSelect, data, isLeft = false, fitParent = false}: {isVisible: boolean, setIsVisible: (isVisible: boolean) => void, value: SelectionItem, title?: string, position?: {x: number, y: number}, onSelect: (item: SelectionItem) => void, data: SelectionItem[], isLeft?: boolean, fitParent?: boolean}) => {
  const theme = useTheme();
  const commonStyles = getCommonStyles(theme)
  return (
    <>
        {fitParent && isVisible && (
            <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, justifyContent: 'center', alignItems: 'center', backgroundColor: theme.colors.primary + '30', zIndex: 100 }} 
            onStartShouldSetResponder={() => true}
            onResponderGrant={(evt) => {
                // Check if the touch is on the backdrop (not on modal content)
                if (evt.target === evt.currentTarget) {
                setIsVisible(false);
                }
            }
            }>
                <View style={{ backgroundColor: 'white', borderRadius: 16, padding: isLeft? undefined: theme.spacing.sm, width: 250 }}>
                    {!!title && <Text type="bodyBold" style={{ marginBottom: theme.spacing.xl, textAlign: 'center' }}>{title}</Text>}
                    <FlatList
                    data={data}
                    keyExtractor={item => item.id}
                    renderItem={({ item, index }) => (
                        <TouchableOpacity
                        style={{ padding: theme.spacing.md, alignItems: isLeft? undefined : 'center', borderBottomWidth: index === data.length -1? 0 : 1, borderBottomColor: theme.colors.lightGrey }}
                        onPress={() => {
                            onSelect(item);
                            setIsVisible(false);
                        }}
                        >
                            <Text type={value.id === item.id ? "bodyBold" : "body"}>{item.name}</Text>
                        </TouchableOpacity>
                    )}
                    />
                </View>
            </View>
        )}
        {!fitParent && <Modal
            visible={isVisible}
            transparent
            animationType="none"
            onRequestClose={() => setIsVisible(false)}
        >
            <TouchableOpacity style={[{ flex: 1, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignItems: 'center' }, position !== undefined && {backgroundColor: 'transparent'}]} onPress={() => setIsVisible(false)} activeOpacity={1}>
                <View style={[{ backgroundColor: 'white', borderRadius: 16, padding: isLeft? undefined: theme.spacing.sm, width: 250 }, position !== undefined && {position: 'absolute', left: position.x, top: position.y}, position !== undefined && commonStyles.shadow]}>
                    {!!title && <Text type="bodyBold" style={{ marginBottom: theme.spacing.xl, textAlign: 'center' }}>{title}</Text>}
                    <FlatList
                    data={data}
                    keyExtractor={item => item.id}
                    renderItem={({ item, index }) => (
                        <TouchableOpacity
                        style={{ padding: theme.spacing.md, alignItems: isLeft? undefined : 'center', borderBottomWidth: index === data.length -1? 0 : 1, borderBottomColor: theme.colors.lightGrey }}
                        onPress={() => {
                            onSelect(item);
                            setIsVisible(false);
                        }}
                        >
                            <Text type={value.id === item.id ? "bodyBold" : "body"}>{item.name}</Text>
                        </TouchableOpacity>
                    )}
                    />
                </View>
            </TouchableOpacity>
        </Modal>}
    </>
  )
}
